import { combineReducers } from "redux";
import authReducer from "./auth";
import messageReducer from "./message";
import userProfileReducer from "./userProfile";
import uploadFormReducer from "./uploadForm";

export default combineReducers({
  authReducer,
  messageReducer,
  userProfileReducer,
  uploadFormReducer
});
